import { takeEvery, put } from 'redux-saga/effects'
import { normalize } from 'normalizr'
import {
  BATCH_IMPORT_SUPPORT_PARAMETERS,
  BATCH_IMPORT_COMPLETE,
} from 'actions/referenceParameter'
import { addToAsyncSet, removeFromAsyncSet } from 'actions/application'
import { duplicateSupportParameter } from 'services/supportParameters.js'
import { supportParameterSchema } from '../schemas/supportParameter'

async function duplicateSP(sp) {
  const spData = await duplicateSupportParameter({
    originalSupportParameter: sp,
  })
  const { data: duplicateParameter } = spData

  const normalized = normalize(duplicateParameter, supportParameterSchema)

  const {
    result,
    entities: { supportParameters },
  } = normalized
  const supportParameter = supportParameters[result]
  return {
    ...supportParameter,
    originalSPUri: sp.uri,
  }
}

function* batchImportSPs(action) {
  const { duplicate, add } = action
  yield put(addToAsyncSet({ signal: BATCH_IMPORT_SUPPORT_PARAMETERS }))
  const supportParameters = yield Promise.all([
    ...duplicate.map(duplicateSP),
    ...add,
  ])
  yield put({ type: BATCH_IMPORT_COMPLETE, supportParameters })

  yield put(removeFromAsyncSet({ signal: BATCH_IMPORT_SUPPORT_PARAMETERS }))
}

export default function* watchBatchSupportParameterImport() {
  yield takeEvery(BATCH_IMPORT_SUPPORT_PARAMETERS, batchImportSPs)
}
